import React from "react";
import { Link } from "react-router-dom";
import { useStore } from "../../context/StoreContext"; // ✅ Use StoreContext
import axios from "../../api/axios";
import { getImageUrl } from "../../utility/imageHelper"; // ✅ Import Image Helper
import { slugify } from "../../utility/slugify";
import { regenerateSitemap } from "../../utility/setSitemap";

const AdminProducts = () => {
  const { products, fetchProducts } = useStore(); // ✅ Fetch from StoreContext

  // Detect duplicate product names
  const nameCounts = products.reduce((acc, p) => {
    acc[p.name] = (acc[p.name] || 0) + 1;
    return acc;
  }, {});

  const duplicateNames = new Set(
    Object.entries(nameCounts)
      .filter(([_, count]) => count > 1)
      .map(([name]) => name)
  );


  // ✅ Handle Product Deletion
  const handleDelete = async (productId) => {
    if (!window.confirm("Are you sure you want to delete this product?")) return;

    // ✅ Retrieve CSRF token from cookies
    const csrfToken = document.cookie
        .split("; ")
        .find(row => row.startsWith("csrfToken="))
        ?.split("=")[1];

    if (!csrfToken) {
        console.error("🚨 CSRF token is missing. Delete request blocked.");
        return;
    }

    try {
        await axios.delete(`/api/admin/products/${productId}`, {
            withCredentials: true,
            headers: { "x-csrf-token": csrfToken }, // ✅ Include CSRF token
        });

        fetchProducts(); // ✅ Refresh StoreContext after deletion
        await regenerateSitemap();
      } catch (error) {
        console.error("🔥 Error deleting product:", error.message);
    }
};


const handleMarkSold = async (id) => {
  if (!window.confirm("Mark this item as SOLD?")) return;

      // ✅ Retrieve CSRF token from cookies
    const csrfToken = document.cookie
        .split("; ")
        .find(row => row.startsWith("csrfToken="))
        ?.split("=")[1];

    if (!csrfToken) {
        console.error("🚨 CSRF token is missing. Delete request blocked.");
        return;
    }

  await axios.put(`/api/admin/products/${id}/mark-sold`, {}, {
    withCredentials: true,
    headers: { "x-csrf-token": csrfToken }
  });

  await fetchProducts();
  await regenerateSitemap();
};



  return (
    <div className="admin-messages-container">
      <h2>Admin: Manage Products</h2>

      {/* ✅ Add New Product Button */}
      <Link to="/admin/products/add" className="add-button">
        + Add New Product
      </Link>

      {/* ✅ Grid Layout for Admin Products */}
      <div className="products-grid admin">
        {products.length > 0 ? (
          products.map((product) => (
            <div
  key={product.id}
  className={`product-card ${
    product.stock === 0
      ? "sold-out"
      : product.stock === 1
      ? "low-stock"
      : ""
  }`}
>

              {/* ✅ Use Image Helper for Consistent Image Handling */}
              {product.images.length > 0 && (
                <div className="main-image-wrapper">
                  {/* SOLD / LOW STOCK BADGES (top-left) */}
                  {product.stock === 0 && (
                    <span className="admin-status-badge sold">SOLD OUT</span>
                  )}

                  {product.stock === 1 && (
                    <span className="admin-status-badge low"> Only 1 Left</span>
                  )}

                  {/* ⭐ FEATURED BADGE — top-right */}
                  {product.featured === 1 && (
                    <div className="admin-featured-badge">
                      ⭐ <span>Featured</span>
                    </div>
                  )}

                  <img
                    src={getImageUrl(product.images[0])}
                    alt={product.name}
                    className="main-product-image"
                  />
                </div>


              )}

              <h3>
                {product.name}
                {duplicateNames.has(product.name) && <> <span>(#{product.id})</span></>}
              </h3>


              <p>${product.price}</p>

              {/* ✅ Admin Controls */}
              <div className="admin-actions">
                <div className="product-actions">
                  <Link to={`/admin/products/${product.id}`} className="view-details">
                    Edit Product
                  </Link>
                  <button onClick={() => handleDelete(product.id)} className="delete-button">
                  ❌ Delete
                  </button>



                </div>
                  {product.stock === 1 && (
                    <button 
                      className="mark-sold-button"
                      onClick={() => handleMarkSold(product.id)}
                    >
                     <i className="fa-solid fa-hand-holding-dollar"></i> Mark as Sold
                    </button>
                  )}
                <Link className="view-product-page" to={`/shop-knives/knife/${product.id}/${slugify(product.name)}`}>
                  <i className="fa-solid fa-expand"></i> View Product Page
                </Link>
              </div>
            </div>
          ))
        ) : (
          <p>No products found. Add a new product!</p>
        )}
      </div>
    </div>
  );
};

export default AdminProducts;
